import { WORDING } from "@/lib/openHouse/wording"
import { MANUSCRIPT_ACCEPT, isPendingFile } from "@/lib/openHouse/editingSteps"
import { ErrorLine, UploadControl } from "./UploadControl"

// Editing's manuscript (phase-1-wording §3): today's editing_posting file,
// required before posting, .doc or .docx. It saves through the page's draft
// save queue like every answer; `value` is the chosen File until that save
// succeeds, then the saved { name }.
//
// Props: field, value, error, upload ({ status, file }), onFile, onRetry, onRemove.

const MANUSCRIPT_WORDS = {
  uploading: WORDING.manuscriptUploading, uploaded: WORDING.manuscriptUploaded, failed: WORDING.manuscriptFailed,
  retry: WORDING.retryUpload, button: WORDING.manuscriptButton, unsupported: WORDING.manuscriptUnsupported,
}

export function ManuscriptUpload({ field, value, error, upload, onFile, onRetry, onRemove }) {
  const saved = value && !isPendingFile(value) ? value.name : null
  // The upload states speak for themselves; the missing-manuscript error shows below.
  const shown = error && error !== WORDING.manuscriptUploading && upload?.status !== "unsupported" ? error : null

  return (
    <div className="flex flex-col gap-2">
      <span className="text-[12.5px] font-bold text-foreground">{field.label}</span>
      <p className="-mt-0.5 text-[12px] leading-snug text-muted-foreground">{WORDING.manuscriptHelp}</p>
      <UploadControl
        saved={saved}
        upload={upload}
        accept={MANUSCRIPT_ACCEPT}
        words={MANUSCRIPT_WORDS}
        onFile={onFile}
        onRetry={onRetry}
        onRemove={onRemove}
      />
      <ErrorLine>{shown}</ErrorLine>
    </div>
  )
}
